import React from "react";
import { Link, Outlet } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./MyProfile.css";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

const MyProfile = () => {
  return (
    <div className="bg_Dark">
      <Header />
      <SubHeader title="My Profile" text="My Profile" width='container' />
      <div className="container ">

        <div className="row text-white my-5">

          <div className="col-lg-3  ">
            <div className="profile-bg py-4 px-3 ">
              <div className="d-flex justify-content-center ">

                <div className='position-relative d-flex mb-3'>
                  <div className="profileImage">
                    <img
                      src={require("../../Asset/userProfile/user.png")}
                      alt="Profile"
                    />
                  </div>
                  <Link  to="profileImg">
                    <div className="edit-img">
                      <img
                        src={require("../../Asset/userProfile/edit.png")}
                        alt="Profile"
                      />
                    </div>
                  </Link>
                </div>
              </div>

              <div className="profileContent text-center mb-5">
                <h3>Rashed Zaman</h3>
                <p>rashed@gmail.com</p>
              </div>
              <Link to="profile">
                <p className="profile-link  my-2 px-2 py-2">
                  <PermIdentityOutlinedIcon /> Profile Information
                </p>
              </Link>

              <Link to="myorder">
                <p className="profile-link  my-2 px-2 py-2">
                  <PermIdentityOutlinedIcon /> My Orders
                </p>
              </Link>

              <Link to="emptymessage">
                <p className="profile-link my-2 px-2 py-2">
                  <EmailOutlinedIcon /> Messages
                </p>
              </Link>

              <Link to="notification">
                <p className="profile-link my-2 px-2 py-2">
                  <NotificationsNoneOutlinedIcon /> Notifications
                </p>
              </Link>
              <Link to="/">
                <p className="profile-link my-2 px-2 py-2">
                  <LogoutOutlinedIcon /> Logout
                </p>
              </Link>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="profile-bg  py-5 px-4 h-100">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyProfile;
